const actions = {
    UNITCLASS_DETAILS_START: 'UNITCLASS_DETAILS_START',
    UNITCLASS_DETAILS_SUCCESS: 'UNITCLASS_DETAILS_SUCCESS',
    UNITCLASS_DETAILS_FAILURE: 'UNITCLASS_DETAILS_FAILURE',

    UNITMESUREMENT_DETAILS_START: 'UNITMESUREMENT_DETAILS_START',
    UNITMESUREMENT_DETAILS_SUCCESS: 'UNITMESUREMENT_DETAILS_SUCCESS',
    UNITMESUREMENT_DETAILS_FAILURE: 'UNITMESUREMENT_DETAILS_FAILURE',

    UNITCONVERSION_DETAILS_START: 'UNITCONVERSION_DETAILS_START',
    UNITCONVERSION_DETAILS_SUCCESS: 'UNITCONVERSION_DETAILS_SUCCESS',
    UNITCONVERSION_DETAILS_FAILURE: 'UNITCONVERSION_DETAILS_FAILURE',

    PRODUCT_UNITCONVERSION_DETAILS_START: 'PRODUCT_UNITCONVERSION_DETAILS_START',
    PRODUCT_UNITCONVERSION_DETAILS_SUCCESS: 'PRODUCT_UNITCONVERSION_DETAILS_SUCCESS',
    PRODUCT_UNITCONVERSION_DETAILS_FAILURE: 'PRODUCT_UNITCONVERSION_DETAILS_FAILURE',

    PRODUCT_GROUP_DETAILS_START: 'PRODUCT_GROUP_DETAILS_START',
    PRODUCT_GROUP_DETAILS_SUCCESS: 'PRODUCT_GROUP_DETAILS_SUCCESS',
    PRODUCT_GROUP_DETAILS_FAILURE: 'PRODUCT_GROUP_DETAILS_FAILURE',

    LOCATION_DETAILS_START: 'LOCATION_DETAILS_START',
    LOCATION_DETAILS_SUCCESS: 'LOCATION_DETAILS_SUCCESS',
    LOCATION_DETAILS_FAILURE: 'LOCATION_DETAILS_FAILURE',

    MAINTAIN_PRICE_DETAILS_START: 'MAINTAIN_PRICE_DETAILS_START',
    MAINTAIN_PRICE_DETAILS_SUCCESS: 'MAINTAIN_PRICE_DETAILS_SUCCESS',
    MAINTAIN_PRICE_DETAILS_FAILURE: 'MAINTAIN_PRICE_DETAILS_FAILURE',

    SALES_DISCOUNT_DETAILS_START: 'SALES_DISCOUNT_DETAILS_START',
    SALES_DISCOUNT_DETAILS_SUCCESS: 'SALES_DISCOUNT_DETAILS_SUCCESS',
    SALES_DISCOUNT_DETAILS_FAILURE: 'SALES_DISCOUNT_DETAILS_FAILURE',

    PURCHASE_PRICE_DETAILS_START: 'PURCHASE_PRICE_DETAILS_START',
    PURCHASE_PRICE_DETAILS_SUCCESS: 'PURCHASE_PRICE_DETAILS_SUCCESS',
    PURCHASE_PRICE_DETAILS_FAILURE: 'PURCHASE_PRICE_DETAILS_FAILURE',


    CLEAR_PRODUCT_DETAILS_START: 'CLEAR_PRODUCT_DETAILS_START',
    CLEAR_PRODUCT_DETAILS_SUCCESS: 'CLEAR_PRODUCT_DETAILS_SUCCESS'
}

export default actions;